import(/* webpackMode: "eager" */ "/root/lp-frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/public/objectiveLast.png");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/src/app/[lang]/category_type/_component/ClientFaqAccordion.js");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/src/app/[lang]/category_type/_component/KeyBenefitsSection.jsx");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/src/app/[lang]/category_type/_component/UniqueFeaturesSection.jsx");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/src/components/Academy.jsx");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/src/components/AccreditationsCarousel.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/lp-frontend/src/components/category_type/IndustryDemandSection.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/lp-frontend/src/components/category_type/IndustryStatsHighlights.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/lp-frontend/src/components/category_type/WhyChooseThisCourses.jsx");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/src/components/DemandCoursesGrid.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["Layout","ContentContainer","Stack","AboutContainer","AboutContent"] */ "/root/lp-frontend/src/components/molecules/index.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/lp-frontend/src/components/molecules/RightEnrollWrapper.jsx");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/src/components/VideoPlayer.jsx");
